import { Typography, LinearProgress } from '@mui/material';
import { IFallback } from '../../interfaces/IFallback';

export default function Fallback({ title = "" }: IFallback) {
    return (
        <div style={{ margin: '10px' }}><Typography variant="h3">Loading {title !== "" ? title : "..."}</Typography><LinearProgress /></div>
    );
}